module.exports = __webpack_public_path__ + "img/hashtag.7be83f41.svg";